import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
/* Actions */
import {getWidgetTypes} from '../../../store/dashboard/dashboard-actions';
/* Components */
import IconButton from '../../common/icon-button/icon-button';
import Select from 'react-select';
import WidgetTypeItem from '../widgets/widget-type-item/widget-type-item';
import Input from '../../common/form-elements/input/input';
import EmptyContent from '../../common/empty-content/empty-content';
import Tooltip from 'rc-tooltip';
import OnboardingTooltipContainer from '../../onboarding/OnboardingTooltipContainer';
/* Styles */
import './widget-type-list.scss';
import {DASHBOARD_EDIT_PAGE_LABEL, SIDEBAR_SECTION} from '../../onboarding/constants';

class WidgetTypeList extends React.PureComponent {
  handleSetSearchCriteria = (searchCriteria) => {
    this.props.setSearchCriteria(searchCriteria);
  };

  handleSetTagCriteria = (selectedTagsOptions) => {
    if (selectedTagsOptions === null) {
      selectedTagsOptions = [];
    }
    this.props.setTagCriteria(selectedTagsOptions);
  };

  handleFilterApply = (e) => {
    e.preventDefault();
    this.props.filterApply();
  };

  handleFilterReset = () => {
    this.props.resetQueryParams();
  };

  getFilterTagsOptions = () => {
    const tagKeys = Object.keys(this.props.availableTags).map((tag) => ({
      ...this.props.availableTags[tag],
    }));
    return tagKeys;
  };

  sortWidgetTypesAlphabeticallyByTitle = (a, b) => {
    const titleA = a.title.toUpperCase();
    const titleB = b.title.toUpperCase();
    if (titleA < titleB) {
      return -1;
    }
    if (titleA > titleB) {
      return 1;
    }

    return 0;
  };

  render() {
    const filterTags = this.getFilterTagsOptions();
    const isEmpty = this.props.widgets.length === 0;
    return (
      <div className="glu-content">
        {this.props.isShown && (
          <OnboardingTooltipContainer
            page={DASHBOARD_EDIT_PAGE_LABEL}
            section={SIDEBAR_SECTION}
            shouldMove={!this.props.isInitiallyOpened}
          />
        )}
        <div className="glu-content__header">
          <div className="glu-flex-row glu-flex-grow glu-flex-align-center">
            <div className="glu-flex-grow">
              <div className="glu-h2">Widgets</div>
            </div>
            <Tooltip placement="top" trigger={['hover']} overlay={<span>Filter</span>}>
              <div className="glu-flex-shrink" onClick={this.props.toggleWidgetFilters}>
                <button className="glu-btn-link">
                  <IconButton
                    icon="filter"
                    className={this.props.areFiltersShown ? 'active' : ''}
                  />
                </button>
              </div>
            </Tooltip>

            <div className="glu-flex-shrink">
              <button
                aria-label="close"
                type="button"
                className="glu-btn-link
                                glu-btn-link--side-padding
                                glu-btn__icon
                                g-icon
                                g-icon-close"
                onClick={this.props.onClose}
              />
            </div>
          </div>
        </div>
        {this.props.areFiltersShown && (
          <div className="glu-content__section--big glu-content__separator">
            <form onSubmit={this.handleFilterApply}>
              <div className="glu-col-24">
                <label className="glu-label">Search</label>
                <Input
                  placeholder="Search by widget name..."
                  onChange={this.handleSetSearchCriteria}
                  value={this.props.widgetsFilterParams.searchCriteria}
                  className="glu-form-input-pad"
                />
              </div>
              <div className="glu-col-24 glu-col-pad--lg">
                <label className="glu-label">Tags</label>
                <Select
                  isMulti
                  onChange={this.handleSetTagCriteria}
                  placeholder="Select widget tags"
                  closeMenuOnSelect={false}
                  isSearchable={false}
                  value={this.props.widgetsFilterParams.selectedTagsOptions}
                  options={filterTags}
                  defaultInputValue=""
                  className="glu-select glu-form-input-pad"
                  classNamePrefix="react-select"
                />
              </div>
              <div className="glu-col-24 glu-col-pad--lg">
                <div className="glu-flex-row glu-flex-justify-end">
                  <div className="glu-col-md-10 glu-col-12">
                    <button
                      type="button"
                      className="glu-col-24 glu-btn glu-btn--secondary"
                      onClick={this.handleFilterReset}
                      disabled={this.props.resetDisabled}
                    >
                      Reset filters
                    </button>
                  </div>
                  <div className="glu-col-md-10 glu-col-12">
                    <button
                      className="glu-col-24 glu-btn glu-btn--primary"
                      type="submit"
                      disabled={this.props.applyDisabled}
                    >
                      Apply filters
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}
        <div
          className={`glu-content__body glu-content__separator
                    ${this.props.areFiltersShown ? ' glu-widget-filter--opened' : ''}`}
        >
          {!isEmpty ? (
            <div tooltip-id="widgets-sidebar">
              {this.props.widgets
                .sort(this.sortWidgetTypesAlphabeticallyByTitle)
                .map((widget, index) => {
                  if (widget.maxRunningWidgets !== 0) {
                    return (
                      /* eslint-disable-next-line react/no-array-index-key */
                      <div className="glu-content__section" key={`${widget.typeId}/${index}`}>
                        <WidgetTypeItem
                          onDragStart={this.props.onDragStart}
                          widget={widget}
                          onClick={this.props.onWidgetCardClick}
                        />
                      </div>
                    );
                  }
                  return null;
                })}
            </div>
          ) : (
            <EmptyContent
              title="No search results."
              info="Try again with different search criteria."
              centered={false}
            />
          )}
        </div>
      </div>
    );
  }
}

WidgetTypeList.propTypes = {
  onClose: PropTypes.func.isRequired,
  widgets: PropTypes.arrayOf(PropTypes.any).isRequired,
  getWidgetTypes: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  onWidgetCardClick: PropTypes.func.isRequired,
  availableTags: PropTypes.objectOf(PropTypes.any).isRequired,
  areFiltersShown: PropTypes.bool,
  toggleWidgetFilters: PropTypes.func.isRequired,
  setSearchCriteria: PropTypes.func.isRequired,
  widgetsFilterParams: PropTypes.objectOf(PropTypes.any).isRequired,
  setTagCriteria: PropTypes.func.isRequired,
  resetQueryParams: PropTypes.func.isRequired,
  filterApply: PropTypes.func.isRequired,
  resetDisabled: PropTypes.bool,
  applyDisabled: PropTypes.bool,
  isShown: PropTypes.bool,
  isInitiallyOpened: PropTypes.bool,
};

WidgetTypeList.defaultProps = {
  areFiltersShown: false,
  resetDisabled: false,
  applyDisabled: false,
  isShown: false,
  isInitiallyOpened: false,
};

function mapDispatchToProps(dispatch) {
  return {
    getWidgetTypes: (query) => getWidgetTypes(dispatch, query),
  };
}

export default connect(null, mapDispatchToProps)(WidgetTypeList);
